import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { AnnouncementBar } from './components/AnnouncementBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel, PRODUCTS } from './components/MetaPixel';
import { HERO_MOCKUP } from './components/HeaderSections';
import { prefetchPage, whenIdle } from './utils/prefetch';
const CHECKOUT_ORIGIN = 'https://megapack-funzionale-365.impultienda.ar';

// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Italian by default; browsers may offer their built-in translator.
    document.documentElement.lang = 'it';
    document.documentElement.removeAttribute('translate');
    document.documentElement.classList.remove('notranslate');
    document.head.querySelectorAll('meta[name="google"][content="notranslate"]').forEach(m => m.remove());
    document.title = 'Megapack Funzionale 365™ — Un anno intero di lezioni funzionali, pronte';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'it'
    });
    ensureMeta({
      name: 'language',
      content: 'Italian'
    });
    ensureMeta({
      name: 'description',
      content: 'Megapack Funzionale 365: 6 volumi, 365 sessioni pronte da insegnare e 5 bonus strategici. Un anno intero di lezioni di allenamento funzionale, pronte oggi a soli 19€.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#020617'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: HERO_MOCKUP,
      fetchpriority: 'high'
    });
    // Warm up the checkout connection so CTA clicks navigate instantly.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://connect.facebook.net'
    });
    // Once the page is idle, fetch the checkout in the background so the
    // buy buttons open it instantly.
    whenIdle(() => prefetchPage(PRODUCTS.mf365.checkoutUrl), 4000);
  }, []);
  return <div lang="it" className="min-h-screen w-full bg-slate-950 text-slate-300 selection:bg-blue-600 selection:text-white" data-id="element-0" data-mp="1m7925eifwo2s">
      <MetaPixel data-id="element-1" data-mp="aqir9i32n82u" />
      <SocialProofPopup data-id="element-2" data-mp="ar28sxot7ugc" />
      <ExitIntentModal data-id="element-3" data-mp="arc1it18ofpq" />
      <AnnouncementBar data-id="element-4" data-mp="ano8rw3mbxc2" />
      <main data-id="element-5" data-mp="qxnmbmr1wgvl">
        <Hero data-id="element-6" data-mp="qxf5xkvpytfn" />
        <SocialProof data-id="element-7" data-mp="qxxbj849uk08" />
        <Testimonials1 data-id="element-8" data-mp="qygmu5zf2a5a" />
        <Problem data-id="element-9" data-mp="m6fdartmuxiy" />
        <ProductTomos data-id="element-10" data-mp="m5x4ywtp4suo" />
        <Bonuses data-id="element-11" data-mp="m5dx68xrfkud" />
        <UrgencyCounter data-id="element-12" data-mp="m4ue2owdiqer" />
        <Pricing data-id="element-13" data-mp="m4m2d0bzlr55" />
        <Testimonials2 data-id="element-14" data-mp="h72npzbdncco" />
        <Guarantee data-id="element-15" data-mp="h8du86w7iy7h" />
        <FAQ data-id="element-16" data-mp="h7vmoe43gxk9" />
        <CostOfNotHaving data-id="element-17" data-mp="h59hgl4oeu57" />
        <FinalCTA data-id="element-18" data-mp="c897w08mb99c" />
      </main>
      <Footer data-id="element-19" data-mp="c9an8gwo2hwv" />
      <StickyMobileCTA data-id="element-20" data-mp="c9khigoqvb8d" />
    </div>;
}